export default [
  {
    path: 'relatorios/gecom-home/gecom-mobile',
    name: 'gecom-mobile',
    component: () => import('./index'),
    children: [],
    meta: {
      visible: true,
      title: 'Gefin',
      breadcrumb: [
        { name: 'Home', link: 'home' },
        { name: 'Relatórios', link: 'relatorios' },
        { name: 'Gefin' },
      ]
    }
  },
]